import { SortableTableSkeleton } from 'app/agriculture/components/Table/SortableTableSkeleton';

export function LevelMonitorListTableSkeleton() {
    return (
        <SortableTableSkeleton
            headCells={[
                { key: 'name', label: 'Name', width: 150 },
                { key: 'level', label: 'Level', width: 30 },
                { key: 'tank', label: 'Tank', width: 50 },
                { key: 'status', label: 'Status', width: 90 },
            ]}
            button={() => ({
                text: 'Edit',
                startIcon: 'edit',
                variant: 'compact',
            })}
        />
    );
}
